<template><div><h1>VUX V2.3.1 发布日志</h1>
<h2><a href="/zh-CN/components/flow.html">Flow</a></h2>
<ul><li>[feature] 新组件</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[fix] 修复 render-function 生成的内容错误显示问题 #1409</li>
</ul>
<h2><a href="/zh-CN/components/picker.html">Picker</a></h2>
<ul><li>[feature] 增加获取对应文字方法 #1418</li>
</ul>
<h2><a href="/zh-CN/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[fix] 修复文字值显示</li>
</ul>
<h2><a href="/zh-CN/components/toast.html">Toast</a></h2>
<ul><li>[feature] 为插件添加 text 方法方便调用</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[feature] 添加 blur 方法 #1422</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.1 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.1-235.vue?5fc8190a